import React, { Component } from "react";
import CustomerContractsAppliedChangesDetailsTable from "./CustomerContractsAppliedChangesDetailsTable";
import "./CustomerContractsAppliedChangesDetails.css";

class CustomerContractsUploadChangesDetails extends Component {
  render() {
    const changesList = this.props.changesList;
    return (
      <div className="changes-details-container">
        <h2>Changes</h2>
        {this.props.changeType === "unknown" ? (
          <div className="customer-change-warning">
            The following customers are unknown to Reposit Power
          </div>
        ) : null}
        <div className="change-table-container">
          <CustomerContractsAppliedChangesDetailsTable
            changesList={changesList}
            changeType={this.props.changeType}
          />
        </div>
        <div className="back-container">
          <span className="link" onClick={this.props.backToSummary}>
            <i className="fa fa-arrow-left" /> File Summary
          </span>
        </div>
      </div>
    );
  }
}

export default CustomerContractsUploadChangesDetails;
